{
  "name": "pflegering-portal-pwa",
  "version": "0.0.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "nuxt build",
    "dev": "nuxt dev",
    "test": "vitest run",
    "test:watch": "vitest",
    "generate": "nuxt generate",
    "preview": "nuxt preview",
    "postinstall": "nuxt prepare",
    "vue-tsc": "vue-tsc --noEmit",
    "oxlint": "oxlint",
    "eslint": "eslint",
    "prettier": "prettier",
    "lint": "oxlint && eslint .",
    "lint:fix": "oxlint --fix && eslint --fix .",
    "format": "npm run vue-tsc && npm run lint:fix && prettier --write --log-level warn .",
    "format:list": "if [ \"$LIST\" ]; then npm run vue-tsc && SRC=`echo \"$LIST\" | grep '.*\\.\\(ts\\|js\\|vue\\)$'`; oxlint --fix $SRC; eslint --fix $SRC; prettier --write $LIST; fi",
    "format:changed": "LIST=`git diff --name-only --diff-filter=d; git ls-files --others --exclude-standard` npm run format:list",
    "format:staged": "LIST=`git diff --name-only --diff-filter=d --cached` npm run format:list",
    "format:check": "npm run vue-tsc && oxlint && eslint . && prettier --check .",
    "prepare": "husky"
  },
  "devDependencies": {
    "@fortawesome/free-brands-svg-icons": "^7.3.0",
    "@fortawesome/free-regular-svg-icons": "^7.3.0",
    "@fortawesome/free-solid-svg-icons": "^7.3.0",
    "@nuxt/eslint": "^1.16.0",
    "@nuxt/fonts": "^0.14.0",
    "@nuxt/test-utils": "^4.2.0",
    "@tailwindcss/vite": "^4.3.2",
    "@types/lodash": "^4.17.24",
    "@types/luxon": "^3.4.2",
    "@types/node": "^22.0.0",
    "@vue/test-utils": "^2.5.0",
    "autoprefixer": "^10.4.20",
    "eslint": "^9.36.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-oxlint": "^1.73.0",
    "happy-dom": "^20.12.0",
    "oxlint": "^1.73.0",
    "postcss": "^8.4.47",
    "prettier": "^3.9.4",
    "sass": "^1.101.0",
    "sass-embedded": "npm:sass@^1.101.0",
    "tailwindcss": "^4.3.2",
    "typescript": "^5.6.0",
    "vitest": "^4.1.11",
    "vue-tsc": "^3.3.7",
    "workbox-cli": "^7.3.0",
    "workbox-precaching": "^7.3.0"
  },
  "dependencies": {
    "@nuxt/image": "^2.0.0",
    "@nuxtjs/i18n": "^10.4.0",
    "@pinia/nuxt": "^0.11.3",
    "@pqina/pintura": "^8.91.5",
    "@pqina/vue-pintura": "^9.0.2",
    "@primevue/forms": "^4.5.5",
    "@primevue/nuxt-module": "^4.5.5",
    "@primevue/themes": "^4.5.4",
    "@selemondev/vue3-signature-pad": "^1.10.0",
    "@sentry/nuxt": "^10.64.0",
    "@sentry/vite-plugin": "^5.3.0",
    "@sentry/vue": "^10.64.0",
    "@tailwindcss/typography": "^0.5.20",
    "@vee-validate/i18n": "^4.15.1",
    "@vee-validate/nuxt": "^4.15.1",
    "@vee-validate/rules": "^4.15.1",
    "@vee-validate/zod": "^4.15.1",
    "@vesp/nuxt-fontawesome": "^2.0.0",
    "@vite-pwa/nuxt": "^1.1.1",
    "@vueuse/core": "^14.3.0",
    "@vueuse/nuxt": "^14.3.0",
    "compressorjs": "^1.3.0",
    "fabric": "^7.4.0",
    "flag-icons": "^7.5.0",
    "heic-to": "^1.5.2",
    "heic2any": "^0.0.4",
    "husky": "^9.1.7",
    "laravel-echo": "^2.3.7",
    "lodash": "~4.17.21",
    "luxon": "^3.7.2",
    "moment": "^2.30.1",
    "nuxt": "^4.4.8",
    "nuxt-security": "^2.6.0",
    "nuxt-signature-pad": "^1.8.0",
    "nuxt-time": "^1.0.3",
    "openai": "^6.45.0",
    "paper": "^0.12.18",
    "pinia": "^3.0.4",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primevue": "^4.5.5",
    "pusher-js": "^8.5.0",
    "signature_pad": "^5.1.3",
    "vee-validate": "^4.15.1",
    "vue": "^3.5.39",
    "vue-matomo": "^4.2.0",
    "vue-router": "^4.6.4",
    "vue3-google-map": "^0.27.1",
    "workbox-core": "^7.3.0",
    "wrangler": "^4.108.0",
    "zod": "^3.24.0"
  },
  "overrides": {
    "vite": "^8.1.3",
    "vue": "^3.5.39"
  }
}
